module.exports = __webpack_public_path__ + "web/static/img/netatmo.049391ed.png";